import { render, staticRenderFns } from "./APVListDeleteButton.vue?vue&type=template&id=f46c301a&scoped=true&"
import script from "./APVListDeleteButton.vue?vue&type=script&lang=js&"
export * from "./APVListDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./APVListDeleteButton.vue?vue&type=style&index=0&id=f46c301a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46c301a",
  null
  
)

export default component.exports